import { useEffect } from 'react';

declare global {
  interface Window {
    Tawk_API?: unknown;
    Tawk_LoadStart?: Date;
  }
}

interface TawkToChatProps {
  isAuthenticated: boolean;
}

const TawkToChat: React.FC<TawkToChatProps> = ({ isAuthenticated }) => {
  useEffect(() => {
    console.log('[TawkToChat] isAuthenticated:', isAuthenticated);

    // Only load Tawk.to if user is authenticated
    if (!isAuthenticated) {
      // Remove Tawk.to if it exists and user logs out
      if (window.Tawk_API && window.Tawk_API.hideWidget) {
        window.Tawk_API.hideWidget();
      }
      return;
    }

    // Check if script is already loaded
    const existingScript = document.getElementById('tawkto-script');
    if (existingScript) {
      // Show widget if it was hidden
      if (window.Tawk_API && window.Tawk_API.showWidget) {
        window.Tawk_API.showWidget();
      }
      return;
    }

    // Initialize Tawk.to
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    const script = document.createElement('script');
    script.id = 'tawkto-script';
    script.async = true;
    script.src = 'https://embed.tawk.to/691e536b86eace1959494bed/1jaf7bnig';
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');

    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }

    return () => {
      // Hide widget on cleanup
      if (window.Tawk_API && window.Tawk_API.hideWidget) {
        window.Tawk_API.hideWidget();
      }
    };
  }, [isAuthenticated]);

  return null;
};

export default TawkToChat;
